import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import moment from 'moment';
import { 
  VALIDATION_DOCUMENT_REVIEW_LIST,
  VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT,
  VALIDATION_DOCUMENT_REVIEW_ADD,
  VALIDATION_DOCUMENT_REVIEW_DETAIL,
  VALIDATION_DOCUMENT_REVIEW_UPDATE,
  VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET
} from '../actions';
import {
  ValidationDocumentReviewListSuccess,
  ValidationDocumentReviewListError,
  ValidationDocumentReviewSearchDeliveryOrderLineLotSuccess,
  ValidationDocumentReviewSearchDeliveryOrderLineLotError,
  ValidationDocumentReviewAddSuccess,
  ValidationDocumentReviewAddError,
  ValidationDocumentReviewDetailSuccess,
  ValidationDocumentReviewDetailError,
  ValidationDocumentReviewUpdateSuccess,
  ValidationDocumentReviewUpdateError,
  ValidationDocumentReviewUploadSetSuccess,
  ValidationDocumentReviewUploadSetError
} from '../actions';
 
export function* watchValidationDocumentReviewList() {
  yield takeEvery(VALIDATION_DOCUMENT_REVIEW_LIST, onValidationDocumentReviewList);
}

export function* watchValidationDocumentReviewSearchDeliveryOrderLineLot() {
  yield takeEvery(VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT, onValidationDocumentReviewSearchDeliveryOrderLineLot);
}

export function* watchValidationDocumentReviewAdd() {
  yield takeEvery(VALIDATION_DOCUMENT_REVIEW_ADD, onValidationDocumentReviewAdd);
}

export function* watchValidationDocumentReviewDetail() {
  yield takeEvery(VALIDATION_DOCUMENT_REVIEW_DETAIL, onValidationDocumentReviewDetail);
}

export function* watchValidationDocumentReviewUpdate() {
  yield takeEvery(VALIDATION_DOCUMENT_REVIEW_UPDATE, onValidationDocumentReviewUpdate);
}

export function* watchValidationDocumentReviewUpload() {
  yield takeEvery(VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET, onValidationDocumentReviewUpload);
}

const onValidationDocumentReviewListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'validation_document_review/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onValidationDocumentReviewUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'validation_document_review/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onValidationDocumentReviewSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onValidationDocumentReviewAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'validation_document_review/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onValidationDocumentReviewDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'validation_document_review/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onValidationDocumentReviewUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/validation_document_review/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_validation_document_reviews/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_validation_document_reviews/'});
      });
    });
  });
};


function* onValidationDocumentReviewList(data) {
  try {
    const response = yield call(onValidationDocumentReviewListAsync, data.payload);
    yield put(ValidationDocumentReviewListSuccess(response.data));
  } catch (error) {
    yield put(ValidationDocumentReviewListError(error));
  }
}

function* onValidationDocumentReviewSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onValidationDocumentReviewSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(ValidationDocumentReviewSearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(ValidationDocumentReviewSearchDeliveryOrderLineLotError(error));
  }
}

function* onValidationDocumentReviewAdd(data) {
  try {
      const response = yield call(onValidationDocumentReviewAddAsync, data);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(ValidationDocumentReviewAddSuccess(response.data));
  } catch (error) {
      yield put(ValidationDocumentReviewAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onValidationDocumentReviewDetail(data) {
  try {
    const response = yield call(onValidationDocumentReviewDetailAsync, data.payload);
    yield put(ValidationDocumentReviewDetailSuccess(response.data.data));
  } catch (error) {
    yield put(ValidationDocumentReviewDetailError(error));
  }
}

function* onValidationDocumentReviewUpdate(data) {
  try {
      const response = yield call(onValidationDocumentReviewUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(ValidationDocumentReviewUpdateSuccess(response.data));
  } catch (error) {
      yield put(ValidationDocumentReviewUpdateError(error));
  }
}

function* onValidationDocumentReviewUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onValidationDocumentReviewUploadAsync, file);
    if(response.message ==='success'){
      yield put(ValidationDocumentReviewUploadSetSuccess(response));
    }
    else{
      yield put(ValidationDocumentReviewUploadSetError(response));
    }
  } catch (error) {
    yield put(ValidationDocumentReviewUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchValidationDocumentReviewList),
    fork(watchValidationDocumentReviewSearchDeliveryOrderLineLot),
    fork(watchValidationDocumentReviewAdd),
    fork(watchValidationDocumentReviewDetail),
    fork(watchValidationDocumentReviewUpdate),
    fork(watchValidationDocumentReviewUpload),
  ]);
} 